import { BsDatepickerViewMode } from '../models';

export function canSwitchMode(mode: BsDatepickerViewMode): boolean {
  return true;
}
